'use strict';


import {registerDzsShowMore} from "./dzs_showmore/_dzs_showmore";
import {dzstoggle_initalltoggles} from "./dzs_common/_dzs_toggle";
import {init_lazyloading} from "./dzs_common/_dzs_lazyloading";
import {
  extraButtonsHelper,
  insertFacebookButtonAfter10000ms,
} from "./js_previewHelpers/_previewHelpers";
import {initScrollToMenuItem} from "./dzs_common/_dzs_scrollToMenuItem";
import {preseterBindings} from "./js_previewHelpers/_preseterBindings";
import {initOtherScripts} from "./js_previewHelpers/_otherScriptLoaders";

window.dzs_loading_as = false;
window.dzs_loading_tr = false;

export function loadStylesheet(arg) {
  var head = document.getElementsByTagName('head')[0];
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = arg;
  link.media = 'all';
  head.appendChild(link);
}
export function loadScript(arg, completeFn) {

  var head = document.getElementsByTagName('head')[0];
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = arg;
  if (completeFn) {

    script.onload = function () {
      completeFn(script);
    };
  }
  head.appendChild(script);
}

export function get_query_arg(purl, key) {
  if (purl.indexOf(key + '=') > -1) {
    var regexS = "[?&]" + key + "(.+?)(?=&|$)";
    var regex = new RegExp(regexS);
    var regtest = regex.exec(purl);


    if (regtest != null && regtest[1]) {
      return regtest[1].replace(/=/g, '');
    }
    return '';
  }
}

window.promiseJqueryReady = () => {
  return new Promise((success, error) => {
    const inter_checkJquery = setInterval(() => {

      if (window.jQuery) {

        success();
        clearInterval(inter_checkJquery);
      }
    }, 10);
    setTimeout(() => {

      success();
      clearInterval(inter_checkJquery);
    }, 10000);
  })
}


jQuery(document).ready(function ($) {

  const $body = $('body');
  $body.addClass('document-ready');


  init_lazyloading();
  initScrollToMenuItem();
  initOtherScripts($);
  extraButtonsHelper($);
  preseterBindings($);
  insertFacebookButtonAfter10000ms();



  if (is_ios()) {
    $body.addClass('is-ios');
  }

});

function is_ios() {
  return ((navigator.platform.indexOf("iPhone") !== -1) || (navigator.platform.indexOf("iPod") !== -1) || (navigator.platform.indexOf("iPad") !== -1)
  );
}

window.dzsshm_self_options = {};


jQuery(document).ready(function ($) {
  registerDzsShowMore()
  dzsshm_init('.showmore-con.auto-init', {init_each: true});


  dzstoggle_initalltoggles();

});


